import React, { useEffect, useState } from "react";
import Sider from "./Sider";
import PageRouter from "./PageRouter";
import Header from "./Header";
import { useStore } from "../StateProvider";
import { getList, URLPRIFIX } from "../../functions/api";
import { getlocal } from "../../functions/localstorage";
import { ToastContainer } from "react-toastify";
import LoadingSpinner from "../Elements/LoadingSpinner";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { RiAdminLine } from "react-icons/ri";
import { MdContentPasteSearch } from "react-icons/md";
import { MdOutlineDashboard } from "react-icons/md";
import { MdApproval } from "react-icons/md";
import { MdTrackChanges } from "react-icons/md";
import { TbHammer } from "react-icons/tb";
import { FaBalanceScale } from "react-icons/fa";
import { PiTrademarkDuotone } from "react-icons/pi";

const Layout = ({ children }) => {
  const store = useStore();
  const user = getlocal("system")?.user || {};
  const [sider, setsider] = useState("max-sm:hidden");
  let props = getlocal("properties") || {};

  if (user?.role == 1) {
    props = new Proxy({}, {
      get: () => new Proxy({}, {
        get: () => true
      })
    });
  }
  // console.log("propscheck", props);

  let category = {};

  let menus = {
    // Dashboard: {
    //   "meta-data": { icon: <MdOutlineDashboard />, parent: true },
    //   link: "/" + URLPRIFIX + "/dashboard",
    //   disabled: !props?.dashboard?.on_off,
    // },
    Dashboard: {
      "meta-data": { icon: <MdOutlineDashboard />, parent: true },
      link: "/" + URLPRIFIX + "/view/dashboard",
      disabled: !props?.dashboard?.on_off,
    },
    Administration: {
      disabled: !(
        props?.users?.on_off ||
        props?.customers?.on_off ||
        props?.categories?.on_off ||
        props?.films?.on_off ||
        props?.contacts?.on_off
      ),
      "meta-data": { icon: <RiAdminLine />, parent: true },
      child: {
        Users: {
          "meta-data": { parent: false },
          link: "/" + URLPRIFIX + "/users/list",
          disabled: !props?.users?.on_off,
        },
        Customer: {
          "meta-data": { parent: false },
          link: "/" + URLPRIFIX + "/customer/list",
          disabled: !props?.customers?.on_off,
        },
        Category: {
          "meta-data": { icon: "", parent: false },
          link: "/" + URLPRIFIX + "/categories/list",
          disabled: !props?.categories?.on_off,
        },
        Film: {
          "meta-data": { icon: "", parent: false },
          link: "demo/filmmaster/list",
          disabled: !props?.films?.on_off,
        },
        Contacts: {
          "meta-data": { icon: "", parent: false },
          link: "/" + URLPRIFIX + "/contacts/list",
          disabled: !props?.contacts?.on_off,
        },

        // CreateLink: {
        //   "meta-data": { icon: "", parent: false },
        //   link: "/"+URLPRIFIX+"/contact/list"
        // },
      },
    },
    "Non-Litigation": {
      disabled: !(
        props?.nonlitigation_projects?.on_off ||
        props?.nonlitigation_documents?.on_off ||
        props?.nonlitigation_tasks?.on_off ||
        props?.nonlitigation_category?.on_off ||
        props?.forms?.on_off
      ),
      "meta-data": { icon: <FaBalanceScale />, parent: true },
      child: {
        Projects: {
          "meta-data": { icon: "", parent: false },
          link: "/" + URLPRIFIX + "/projects/list",
          disabled: !props?.nonlitigation_projects?.on_off,
        },
        Documents: {
          "meta-data": { icon: "", parent: false },
          link:
            user.role === 1
              ? "/" + URLPRIFIX + "/documents/list"
              : "/" +
              URLPRIFIX +
              "/documents/list?field=assigned_to&search=" +
              user.id,
          disabled: !props?.nonlitigation_documents?.on_off,
        },
        Task: {
          "meta-data": { icon: "", parent: false },
          child: {
            "All Task": {
              "meta-data": { icon: "", parent: false },
              link: "/" + URLPRIFIX + "/tasks/list",
              disabled: !(
                [1].includes(user?.role) &&
                props?.nonlitigation_tasks?.on_off
              ),
            },
            "Assigned_to Me": {
              "meta-data": { icon: "", parent: false },
              link:
                "/" +
                URLPRIFIX +
                "/tasks/list/" + user?.id,
              disabled: !props?.nonlitigation_tasks?.on_off,
            },
            "Pending Approval": {
              "meta-data": { icon: "", parent: false },
              link:
                "/" +
                URLPRIFIX +
                "/tasks/list?field=status&search=waitingforapproval",
              disabled: !(
                [1].includes(user?.role) &&
                props?.nonlitigation_tasks?.on_off
              ),
            },
            "Overdue Tasks": {
              "meta-data": { icon: "", parent: false },
              link: "/" + URLPRIFIX + "/non-litigation/overdue-tasks",
              disabled: !props?.nonlitigation_tasks?.on_off,
            },
          },
          disabled: !props?.nonlitigation_tasks?.on_off,
        },
        Categories: {
          "meta-data": { icon: "", parent: false },
          child: category,
          disabled: !props?.nonlitigation_category?.on_off,
        },
        "Customer Form": {
          "meta-data": { icon: "", parent: false },
          disabled: !props?.forms?.on_off,
          child: {
            "All Forms": {
              "meta-data": { icon: "", parent: false },
              link: "/" + URLPRIFIX + "/forms/list",
              disabled: !props?.forms?.on_off,
            },
            "Submitted Forms": {
              "meta-data": { icon: "", parent: false },
              link:
                "/" + URLPRIFIX + "/forms/list?field=status&search=Submitted",
              disabled: !props?.forms?.on_off,
            },
          },
        },
      },
    },
    Litigation: {
      disabled: !(
        props?.litigation_projects?.on_off || props?.litigation_tasks?.on_off
      ),
      "meta-data": { icon: <TbHammer />, parent: true },
      child: {
        Projects: {
          "meta-data": { icon: "", parent: false },
          link: "/" + URLPRIFIX + "/litigation/projects/list",
          disabled: !props?.litigation_projects?.on_off,
        },
        Task: {
          "meta-data": { icon: "", parent: false },
          disabled: !props?.litigation_tasks?.on_off,
          child: {
            "All Task": {
              "meta-data": { icon: "", parent: false },
              link: "/" + URLPRIFIX + "/litigation/tasks/list",
              disabled: !(
                [1].includes(user?.role) && props?.litigation_tasks?.on_off
              ),
            },
            "Assigned_to Me": {
              "meta-data": { icon: "", parent: false },
              link:
                "/" +
                URLPRIFIX +
                "/litigation/tasks/list/" +
                user?.id,
              disabled: !props?.litigation_tasks?.on_off,
            },
            "Pending Approval": {
              "meta-data": { icon: "", parent: false },
              link:
                "/" +
                URLPRIFIX +
                "/litigation/tasks/list?field=status&search=waitingforapproval",
              disabled: !(
                [1].includes(user?.role) && props?.litigation_tasks?.on_off
              ),
            },
          },
        },
      },
    },
    TradeMark: {
      disabled: !(
        props?.trademark_projects?.on_off || props?.trademark_tasks?.on_off
      ),
      "meta-data": { icon: <PiTrademarkDuotone />, parent: true },
      child: {
        Projects: {
          "meta-data": { icon: "", parent: false },
          link: "/" + URLPRIFIX + "/trademark/projects/list",
          disabled: !props?.trademark_projects?.on_off,
        },

        Task: {
          "meta-data": { icon: "", parent: false },
          // link: "/" + URLPRIFIX + "/trademark/tasks/list",
          disabled: !props?.trademark_tasks?.on_off,
          child: {
            "All Task": {
              "meta-data": { icon: "", parent: false },
              link: "/" + URLPRIFIX + "/trademark/tasks/list",
              disabled: !(
                [1].includes(user?.role) && props?.trademark_tasks?.on_off
              ),
            },
            "Assigned_to Me": {
              "meta-data": { icon: "", parent: false },
              link:
                "/" +
                URLPRIFIX +
                "/trademark/tasks/list/" +
                user?.id,
              disabled: !props?.trademark_tasks?.on_off,
            },
            "Pending Approval": {
              "meta-data": { icon: "", parent: false },
              link:
                "/" +
                URLPRIFIX +
                "/trademark/tasks/list?field=status&search=waitingforapproval",
              disabled: !(
                [1].includes(user?.role) && props?.trademark_tasks?.on_off
              ),
            },
            "Overdue Tasks": {
              "meta-data": { icon: "", parent: false },
              link: "/" + URLPRIFIX + "/trademark/tasks/overdue",
              disabled: !props?.trademark_tasks?.on_off,
            },
          },
        },
      },
    },
    "Template Master": {
      "meta-data": { icon: <MdContentPasteSearch />, parent: true },
      link: "/" + URLPRIFIX + "/template-master",
      disabled: !props?.template_master?.on_off,
    },
    Accounts: props?.companydashboard?.on_off
      ? {
        "meta-data": {
          parent: true,
          icon: <MdOutlineAccountBalanceWallet />,
        },
        link: "/" + URLPRIFIX + "/companyaccounts/dashboard",
      }
      : {
        "meta-data": {
          parent: true,
          icon: <MdOutlineAccountBalanceWallet />,
        },
        link: "/" + URLPRIFIX + "/accounts",
        // "/" + URLPRIFIX + "/" + user.company + "/accounts/expense",
        disabled: !props?.companies?.on_off,
      },

    Profile: {
      "meta-data": {
        icon: <CgProfile />,
        parent: true,
      },
      child: {
        "My Profile": {
          "meta-data": { parent: false },
          link: "/" + URLPRIFIX + "/users/profile/" + (user?.id || "0"),
          disabled: !props?.users?.view,
        },
        // "Profile Setting": {
        //   "meta-data": { icon: "", parent: false },
        //   link: "/"+URLPRIFIX+"/profile",
        // },
        Logout: {
          "meta-data": { icon: "", parent: false },
          button: "logout",
        },
      },
    },
  };

  let AccountsMenu = {
    Sales: {
      // disabled: user?.role != "1",
      "meta-data": {
        // icon: <RiAdminLine />,
        parent: true,
      },
      // child: {
      //   Users: {
      //     "meta-data": { parent: false },
      //     link: "/" + URLPRIFIX + "/users/list",
      //     disabled: !props?.users?.view,
      //   },
      // },
    },
  };

  useEffect(() => {
    store.stopLoading();
    getList({
      listUrl: "/clientcategory/getClientCategorylist",
      field: "",
      sort: "asc",
      page: 1,
      count: 100,
    }).then((res) => {
      console.log("Responces of category");
      if (res.success) {
        res?.data?.list?.map((item) => {
          category[item.categoryName] = {
            "meta-data": { icon: "", parent: false },
            link: "/" + URLPRIFIX + "/nonlitigation/" + item.categoryName,
          };
        });
      }
    });
    // Hotel: {
    //   "meta-data": { icon: "", parent: false },
    //   link: "/demo/nonlitigation/hotel",
    // },
  }, []);

  // the menu has some indicators to classify
  // every object has major components like
  //   1. "meta-data" - has the basic infor like icon location and this object is parent or not as Boolean
  //   2. child - which has the info like what are the child the going to have
  //   3. link - which create the object as a link button so we can easy to navigate to the link
  //   4. button - which help to perform any function which the store has

  return (
    <>
      <main className=" h-screen max-sm:h-svh bg-secondary text-primary font-times grid grid-rows-12 relative">
        <div className=" row-span-1 max-sm:row-span-1 h-12">
          <Header store={store} setsider={setsider} />
        </div>
        <div className="flex row-span-11 max-sm:row-span-12 overflow-hidden h-full w-full">
          <div
            className={
              "h-full bg-primary rounded-tr-[50px] Scrollleft transition-all duration-300 " +
              sider
            }
            style={{ width: store.getsystemvalue("sidebar_collapsed") ? '72px' : '260px', flexShrink: 0 }}
          >
            <div className="innerscroll bg-primary text-secondary h-full max-sm:rounded-none max-sm:absolute max-sm:right-0 max-sm:w-full max-sm:z-50">
              <Sider menus={menus} setsider={setsider} />
            </div>
          </div>
          <div className="flex-1 overflow-x-auto px-[2%] pt-2 relative h-full">
            {store.getsystemvalue("loading") && <LoadingSpinner />}
            {children}{" "}
          </div>
        </div>
      </main>
    </>
  );
};

export default Layout;
